import gql from 'graphql-tag';
const updateChef = gql`mutation updateChef($chef: ChefInput!){
    updateChef(chef:$chef)
}`
export default updateChef
